import AutoTieoutWorkflowData from 'models/api/auto-tieout/auto-tieout-workflow-data-api-model';
import { handleActions } from 'redux-actions';
import {
  autoTieoutWorkflowDataError,
  autoTieoutWorkflowDataLoaded,
  autoTieoutWorkflowDataLoading,
  resetAutoTieoutWorkflowData,
} from 'store/actions/auto-tieout/workpaper-details-action';

export default handleActions(
  {
    [autoTieoutWorkflowDataLoaded]: (autoTieoutWorkflowData, { payload }) => {
      return autoTieoutWorkflowData.setLoaded(payload);
    },
    [autoTieoutWorkflowDataLoading]: (autoTieoutWorkflowData) => {
      return autoTieoutWorkflowData.setLoading();
    },
    [autoTieoutWorkflowDataError]: (autoTieoutWorkflowData, { error }) => {
      return autoTieoutWorkflowData.setError(error);
    },
    [resetAutoTieoutWorkflowData]: () => {
      return new AutoTieoutWorkflowData();
    },
  },
  new AutoTieoutWorkflowData(),
);
